import ConfirmPinModal from '@/components/ConfirmPinModal';
import { ApiContext, type ApiContextType } from '@/contexts/ApiContext';
import { analyticsService } from '@/services/AnalyticsService';
import { authService } from '@/services/AuthService';
import { cryptoService } from '@/services/CryptoService';
import { giftcardService } from '@/services/GiftcardService';
import { notificationService } from '@/services/NotificationService';
import { systemService } from '@/services/SystemService';
import { transactionService } from '@/services/TransactionService';
import { userService } from '@/services/UserService';
import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';

interface ApiProviderProps {
  children: ReactNode;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children }) => {
  const [showPinModal, setShowPinModal] = useState(false);

  useEffect(() => {
    const handleVerifyPin = () => {
      setShowPinModal(true);
    };

    window.addEventListener('verify-pin-request', handleVerifyPin as EventListener);
    return () => window.removeEventListener('verify-pin-request', handleVerifyPin as EventListener);
  }, []);

  const value: ApiContextType = {
    auth: authService,
    user: userService,
    analytics: analyticsService,
    transaction: transactionService,
    giftcard: giftcardService,
    crypto: cryptoService,
    system: systemService,
    notification: notificationService,
  };

  const handlePinConfirmed = () => {
    setShowPinModal(false);
    window.dispatchEvent(new CustomEvent('pin-verified'));
  };

  return (
    <ApiContext.Provider value={value}>
      {children}
      <ConfirmPinModal
        open={showPinModal}
        onClose={() => setShowPinModal(false)}
        onConfirm={handlePinConfirmed}
      />
    </ApiContext.Provider>
  );
};

